const EaglesNestJson = [
    {
        title: "Queenstown apartment",
        slugName: "f",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/slider2.jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/slider2.jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
    {
        title: "Wakatipu Lake View",
        slugName: "",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view5.jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view5.jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
    {
        title: "Dining",
        slugName: "",
        intro: " ",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view4 (2).jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view4 (2).jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
    {
        title: "Hill Lounge",
        slugName: "",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view4.jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view4.jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
    {
        title: "Wakatipu Lake",
        slugName: "",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/AmityQT-30 (Custom).jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/AmityQT-30 (Custom).jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
    {
        title: "Double Bedroom with spa",
        slugName: "",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view13.jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view13.jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
  
    {
        title: "Three Bedroom Accommodation",
        slugName: "",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view4.jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view4.jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
    {
        title: "Wakatipu Lake view bedroom",
        slugName: "",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view12.jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view12.jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
    {
        title: "TV",
        slugName: "f",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view3.jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view3.jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
   
    {
        title: "Queenstown Hill Apartment Queenstown",
        slugName: "",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/out.jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/out.jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },


    {
        title: "Queenstown Hill Apartment Queenstown",
        slugName: "",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/1bed-room-apt1.jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/1bed-room-apt1.jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
  

    {
        title: "Queenstown Hill Apartment Queenstown",
        slugName: "",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view3.jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view3.jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
    {
        title: "Queenstown Hill Apartment Queenstown",
        slugName: "",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view4 (2).jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view4 (2).jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
    {
        title: "Queenstown Hill Apartment Queenstown",
        slugName: "",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view9.jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view9.jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
    {
        title: "Queenstown Hill Apartment Queenstown",
        slugName: "",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view10.jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view10.jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },  {
        title: "Queenstown Hill Apartment Queenstown",
        slugName: "",
        intro: "",
        previewImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view14.jpg",
        bannerImage: "https://d2057z2iq79qyw.cloudfront.net/amity/sea-view14.jpg",
        fullDescription: "<p>&nbsp;</p> <p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>",
        metaTitle: "",
        metaDesc: "",
        metaKeywords: "",
    },
  
   
]

export default EaglesNestJson;
